define(function (require, exports, module) {
    // dependency requires
    const MessageService = require('message-service/message-service');
    const extant = require('extant/extant');

    // pacemaker classes this'll be fun
    const Pacemaker = require('game-data-pacemaker/main');
    const GameModelLocator = require('game-data-pacemaker/js/control/GameModelLocator');
    const TfsManager = require('game-data-pacemaker/js/control/TfsManager');
    const DataEvents = require('game-data-pacemaker/js/enums/DataEvents');
    const DatasourceSelector = require('game-data-pacemaker/js/load/execute/DataSourceSelector');

    // project level imports
    const EventTypes = require('./enum/events/EventTypes');
    const DatasourceDeclarations = require('./control/DatasourceDeclarations');
    const logg = require('./util/window/Logg');
    const Gamestates = require('./enum/baseball/GamestateDeclarations');
    const GDConfig = require('./util/resources/GDConfig');

    function GameDayCore () {
        // I am a singleton. look at me go.
    }

    GameDayCore.prototype = {
        logger: logg,
        // TODO: get the GDConfig from the configurator!
        GDConfig,

        // Access to the class from the prototype
        GameDayCore,

        /**
         * Allow GameDayCore to return a new instance (mostly used for unit test comparing between legacy and api data)
         */
        create: function () {
            return new GameDayCore();
        },

        /**
         * Function init
         * @param gid {String} gid game id to run with (optional if game value is in urlHash
         * @param opts {Object} opts various config settings that can be passed in
         *
         * kicks everything off (of course)
         */
        init: function (gid, opts) {
            opts = opts || {};
            GDConfig.initProps = opts;
            GDConfig.language = (GDConfig.language || opts.language || 'en');
            GDConfig.apiSite = GDConfig.language;
            // if logging is called for in the options, set up Curveball debugging
            if (extant(opts.logging)) {
                GDConfig.log = opts.logging || 'none';
                logg.setLevel(GDConfig.log); // {level: 'none', ns: "GDC"}
            }

            // if passive mode is called for store it as a game heartbeat will not be created
            if (extant(opts.dataMode)) {
                GDConfig.dataMode = opts.dataMode;
                if (opts.dataMode === 'passive') {
                    GDConfig.passiveMode = true;
                }
            } else if (opts.passiveMode === true) {
                GDConfig.passiveMode = true;
            }

            // override socketMode if not disabled through the config
            if (opts.disableWebSockets !== true) {
                GDConfig.socketMode = true;
            }

            if (opts.forceWebSockets === true) {
                GDConfig.socketMode = true;
                GDConfig.initProps.disableWebSockets = false;
                GDConfig.forceWebSockets = opts.forceWebSockets;
            } else if (opts.forceWebSockets === false) {
                GDConfig.socketMode = false;
                GDConfig.initProps.disableWebSockets = true;
                GDConfig.forceWebSockets = opts.forceWebSockets;
            }

            // if (opts.game) {
            //     var useme = GID(opts.game);
            //     opts.game = useme.pk;
            // }

            if (extant(opts.testVideoAds)) {
                GDConfig.testVideoAds = opts.testVideoAds;
            }

            TfsManager.init(opts.tfsStartTime || opts.tfsStart || opts.tfs || null, GDConfig.passiveMode !== true && !extant(opts.tfsHold));

            // init the heartbeat class
            Pacemaker.init(DatasourceDeclarations, GDConfig, Gamestates);

            // if options contain supported video declaration override the defaults
            if (extant(opts.supportedVideo) || extant(opts.playbackScenarios) || extant(opts.videoFormats)) {
                GDConfig.supportedVideo = [].concat(opts.supportedVideo || opts.playbackScenarios || opts.videoFormats);
            }

            // assign the Datasources to datasource-manager ...
            DatasourceSelector.addSources(opts.dataOverrides || {});

            // add a listener of our own
            MessageService.on.call(this, DataEvents.GAME_INITIALIZED, this.initView);

            // start the process!
            GameModelLocator.getGame(opts.game, opts);
        },

        /**
         * Function removeGameFromCache
         * @param gameID - gameID to remove form GameModelLocator cache
         */
        destroyGame: function (gameID) {
            GameModelLocator.destroyGame(gameID);
        },

        /**
         * Function start
         * @param opts {Object} this object is generated internally
         *
         *  you would think this was init, but it's start. start happens after init
         */
        start: function (opts) {
            const currentGame = GameModelLocator.getCurrentGame();
            // hold yr horses if there's no game ready, this will get called again when there is
            if (!extant(currentGame) || !currentGame.initialized) {
                logg.log('the game is not yet ready, this function will be recalled when it is...');
                return;
            }

            logg.log('attempting start...');
        },

        /**
         * function initView
         * @param evt {Object} event data object
         * @param payload {*} payload whatever was passed along with the event
         *
         * this calls start function after the min required files are ready in the model
         */
        initView: function (evt, payload) {
            // dispense with the listener amd spin 'er up
            MessageService.removeListener(DataEvents.GAME_INITIALIZED, this.initView);
            this.start();
        },

        /**
         * function getGameData
         * @param flavor {*} string, array, object or comma delineated list as string of which data point is needed
         * @retuns {Object} modelVO with each requested data point as an attribute containing the VO for that datasource
         *
         * the main access point for any already loaded data, passing no argument returns the sum total of all game data
         * the model locator will deliver only the data of the 'active' game, if there is one, so no game id is needed
         */
        getGameData: function (flavor) {
            return GameModelLocator.getGameData(flavor);
        },

        /**
         * function requestGameData
         * @param flavor {*} string, array, object or comma delineated list as string of which data point is needed
         * @param params {Object} optional collection of name-value pairs to add to the Load call
         * @returns {String} unique 1-time event id that data will be dispatched over once Load completed
         *
         * the function to call for any data point that is not on the heartbeat (ie, loaded on the regular)
         * this will examine each source to see if it is expired, if not it will simply use the current value
         * also if the data Load fails, it will return the current value (which could conceivably be null)
         * once all data is ready, it will dispatch an event with the unique ID returned from this function
         */
        requestGameData: function (flavor, params) {
            return GameModelLocator.requestGameData(flavor, params);
        },

        /**
         * function getCurrent
         * @returns {Object} returns GameItem object for the active game if there is one
         */
        getCurrent: function () {
            return GameModelLocator.getCurrentGame();
        },

        pauseHeartbeat: function () {
            this.getCurrent().pauseHeartbeat();
        },
        stopHeartbeat: function () {
            this.getCurrent().stopHeartbeat();
        },
        unStopHeartbeat: function () {
            this.getCurrent().unStopHeartbeat();
        },
        startHeartbeat: function () {
            this.getCurrent().startHeartbeat();
        },
        updateConfig: function (config) {
            const { disableWebSockets, webSocketWindow, forceWebSockets } = config;
            const { disableWebSockets: initDisableWebSockets } = GDConfig.initProps;
            if (forceWebSockets == null) {
                GDConfig.initProps = { ...GDConfig.initProps, disableWebSockets: (initDisableWebSockets || disableWebSockets), webSocketWindow };
                GDConfig.socketMode = !GDConfig.initProps.disableWebSockets;
                this.getCurrent().updateConfig(GDConfig);
            }
        },
        switchGame: function (payload, evt) {
            payload = payload || {};
            GameModelLocator.switchGame(payload.game || payload, payload.tfs || payload.tfsStartTime || payload.tfsStart, payload.tfsHold);
        },

        /**
         *  Function addListener
         *  @param eventName {String} event to listen to
         *  @param handler {Function} scoped function to act as event handler
         *
         *  central location to add listeners to the Curveball event dispatcher
         */
        addListener: function (eventName, handler) {
            logg.log('subscribing to event: ', eventName);
            MessageService.addListener.call(this, eventName, handler);
        },

        /**
         * Function removeListener()
         * @param eventName {String} the event to no longer listen to
         * @param handler {Function} scoped function to remove from the handler list
         *
         * centralized location to remove listeners from the Curveball event dispatcher
         */
        removeListener: function (eventName, handler) {
            MessageService.removeListener.call(this, eventName, handler);
        },

        /**
         * Function loadAtTfsPoint
         * @param $timecode {String} the time at which to Load
         *
         * this will set the time code to the passed value then Execute a Load of all requested data in 'passive' mode
         */
        loadAtTfsPoint: function ($timecode) {
            TfsManager.setTimecode($timecode);
            this.getCurrent().executePassiveLoad();
        },

        /**
         * Function syncAtTfsPoint
         * @param $timecode {String} the time at which to Load
         *
         * this will set the time code to the passed value, reset, and then Execute a Load of all requested data in 'passive' mode
         */
        syncAtTfsPoint: function ($timecode) {
            TfsManager.beginSync();
            TfsManager.setTimecode($timecode, true);
            this.getCurrent().executePassiveLoad();
        },
        /**
         * Function resetTfs
         *
         * Reset the internal tfs state, stopping sync and using next incoming timecodes as the starting point.
         */
        resetTfs: function () {
            TfsManager.stopSync();
            TfsManager.resetTimecode();
        },
        /**
         * Function beginCommercialBreak
         */
        beginCommercialBreak: function () {
            MessageService.publish(EventTypes.BEGIN_COMMERCIAL_BREAK);
        },

        /**
         * Function endCommercialBreak
         */
        endCommercialBreak: function () {
            MessageService.publish(EventTypes.END_COMMERCIAL_BREAK);
        },

        /**
         * Function handleCommercialCompanionAd
         * @param payload {Object}
         */
        handleCommercialCompanionAd: function (payload) {
            MessageService.publish(EventTypes.COMMERCIAL_COMPANION_RECEIVED, payload);
        },

        getConfig: function () {
            return GDConfig;
        }
    };

    const currentInstance = new GameDayCore();
    return currentInstance;
});
